import React from "react";

function AboutSection() {
  return (
    <section id="about" className="section about">
      <div className="about__grid">
        <div className="about__copy">
          <p className="eyebrow">About byond care</p>
          <h2>Built by people who run clinics, for people who run clinics.</h2>
          <p className="about__highlight">
            byond care didn&apos;t start in a tech incubator. It started in a clinic.
          </p>
          <p>
            Our team has been running primary care clinics in Malaysia for years.
            We&apos;ve sat at the front desk when the queue backed up. We&apos;ve watched
            doctors spend the last hour of their day on paperwork instead of
            patients.
          </p>
          <p>
            So we built what we wished existed. A clinic management system built
            from the inside out, designed around how clinics actually work.
          </p>
          <p>
            And we went further. Because good healthcare doesn&apos;t stop at the
            clinic door, it follows the patient home, into their life, and back
            again.
          </p>
          <div className="about__partners">
            <article className="about__partner-card">
              <h3>XsBenefits — Patient health app</h3>
              <p>
                The XsBenefits app gives every byond care patient their own health
                records, lab results, and clinic communication channel.
              </p>
            </article>
            <article className="about__partner-card">
              <h3>KiraOS — Accounting ERP partner</h3>
              <p>
                AI-native accounting and financial reporting, available to byond
                care subscribers at an exclusive 50% off.
              </p>
            </article>
          </div>
        </div>

        <aside className="about__mission">
          <p className="eyebrow">Our mission</p>
          <h3>Healthcare that goes beyond.</h3>
          <p>
            Our mission is to connect every clinic with every patient making
            healthcare more accessible, more continuous, and more human.
          </p>
        </aside>
      </div>
    </section>
  );
}

export default AboutSection;
